/**
 * Global namespace for `data-bs-title` attribute.
 */
const dataOriginalTitle = 'data-original-title';
export default dataOriginalTitle;
